import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer } from "recharts";
import { CAP_LABELS } from "@/lib/api";

const CORE_CAPS = ["push", "pull", "squat", "bend_lift", "rotation", "endurance"];

export default function ScoreRadar({ baseline, current }) {
  const data = CORE_CAPS.map((cap) => ({
    cap: CAP_LABELS[cap],
    Baseline: baseline?.[cap] ?? 0,
    Current: current?.[cap] ?? 0,
  }));

  return (
    <div data-testid="scorecard-radar" className="w-full h-[320px]">
      <ResponsiveContainer>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#27272a" />
          <PolarAngleAxis dataKey="cap" tick={{ fill: "#a1a1aa", fontSize: 11, fontWeight: 700 }} />
          <Radar name="Baseline" dataKey="Baseline" stroke="#71717a" fill="#71717a" fillOpacity={0.25} />
          <Radar name="Current" dataKey="Current" stroke="#ff5c1a" fill="#ff5c1a" fillOpacity={0.3} />
        </RadarChart>
      </ResponsiveContainer>
      <div className="flex justify-center gap-6 text-[10px] uppercase tracking-[0.2em]">
        <span className="flex items-center gap-2 text-zinc-400">
          <span className="w-3 h-3 bg-zinc-500 inline-block" /> Baseline
        </span>
        <span className="flex items-center gap-2 text-volt">
          <span className="w-3 h-3 bg-volt inline-block" /> Current
        </span>
      </div>
    </div>
  );
}
